import React, {useState} from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRulerTriangle} from "@fortawesome/pro-light-svg-icons/faRulerTriangle";
import FsLightbox from "fslightbox-react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Lang from "lang.js";
import messages from "../messages";
const lang = new Lang({messages, fallback: "nl"});

const Units = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUnitId, setSelectedUnitId] = useState(null);

    const [lightboxControllers, setLightboxControllers] = useState({});

    function openLightboxOnSlide(unitId, number) {
        setLightboxControllers(prevControllers => ({
            ...prevControllers,
            [unitId]: {
                toggler: !((prevControllers[unitId] || {}).toggler || false),
                slide: number
            }
        }));
    }

    function toggleModal(unitId) {
        setSelectedUnitId(unitId);
        setIsOpen(!isOpen);
    }

    return (
        <>
            <style>
                {`
                .main-column-right {
                    z-index: unset !important;
                }

                .card {
                    background-color: transparent;
                }

                .modal-dialog {
                    max-width: 800px;
                }

                .modal-body {
                    max-height: 70vh;
                    overflow-y: auto;
                }

                .unit-image {
                    /* Removed zoom effect as requested */
                    max-width: 100%;
                }
                .unit-hover:hover {
                    background-color: #dddddd;
                    cursor: pointer;
                }
                `}
            </style>
            {props.units.map((unit) =>
                <React.Fragment key={unit.id}>
                    <div className="mb-2 unit-hover" onClick={() => toggleModal(unit.id)}>
                        <div className="mb-2">
                            <h2 className="kenmerkenTitel mb-0">{unit.name}</h2>
                        </div>
                        <div className="row position-relative">
                            <div className="col-sm-5">
                                <div className="rounded position-relative"
                                      style={{
                                          backgroundImage: unit.images?.[0]?.url
                                              ? `url(${unit.images[0].url})`
                                              : '',
                                          backgroundSize: 'cover',
                                          backgroundPosition: 'center',
                                          aspectRatio: '16 / 9',
                                          marginLeft: 'auto',
                                          marginRight: 'auto',
                                          cursor: 'pointer'
                                      }}>
                                    {/* Image counter overlay (Funda style) */}
                                    {unit.images && unit.images.length > 0 && (
                                        <div
                                            className="position-absolute d-flex align-items-center justify-content-center"
                                            style={{
                                                bottom: '10px',
                                                right: '10px',
                                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                color: 'white',
                                                borderRadius: '4px',
                                                padding: '3px 8px',
                                                fontSize: '12px'
                                            }}
                                        >
                                        </div>
                                    )}

                                    {/* Photo gallery button (Funda style) */}
                                    {unit.images && unit.images.length > 1 && (
                                        <div
                                            className="position-absolute d-flex align-items-center justify-content-center" onClick={(e)=> {
                                                e.stopPropagation();
                                            openLightboxOnSlide(unit.id, 1)
                                        }}
                                            style={{
                                                bottom: '10px',
                                                left: '10px',
                                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                color: 'white',
                                                borderRadius: '4px',
                                                padding: '3px 8px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            <span>1/{unit.images.length}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-7">
                                <div className="d-flex justify-content-between align-items-start ">
                                    <div>
                                        {(() => {
                                            const bothSalesAndRent = !!unit.rental_status && !!unit.sales_status;

                                            if (bothSalesAndRent) {
                                                return (
                                                    <div className="mb-3 mt-2 mt-md-0">
                                                        <div className="d-flex align-items-center">
                                                            <div
                                                                className={`badge ${unit.raw_sales_status === "available" ? "badge-success" : "badge-info"} text-lowercase mr-1`}
                                                                style={{ fontSize: "11px", padding: "7px" }}
                                                            >
                                                                {unit.sales_status}
                                                            </div>
                                                            <div
                                                                className={`badge ${unit.raw_rental_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                                                style={{ fontSize: "11px", padding: "7px" }}
                                                            >
                                                                {unit.rental_status}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <>
                                                        {!!unit.sales_status &&
                                                            <div className="mb-3 mt-2 mt-md-0">
                                                                <div
                                                                    className={`badge ${unit.raw_sales_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                                                    style={{ fontSize: "11px", padding: "7px" }}
                                                                >
                                                                    {unit.sales_status}
                                                                </div>
                                                            </div>
                                                        }
                                                        {!!unit.rental_status &&
                                                            <div className="mb-3 mt-2 mt-md-0">
                                                                <div
                                                                    className={`badge ${unit.raw_rental_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                                                    style={{ fontSize: "11px", padding: "7px" }}
                                                                >
                                                                    {unit.rental_status}
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                );
                                            }
                                        })()}

                                        {(() => {
                                            const bothPrices = !!unit.full_sales_price && !!unit.full_rental_price;

                                            if (bothPrices) {
                                                return (
                                                    <div className="d-flex flex-wrap">
                                                        <div className="h6">{unit.full_sales_price}</div>
                                                        <div className="h6 mx-2">/</div>
                                                        <div className="h6">{unit.full_rental_price}</div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <>
                                                        {!!unit.full_sales_price &&
                                                            <div className="h5">{unit.full_sales_price}</div>
                                                        }
                                                        {!!unit.full_rental_price &&
                                                            <div className="h5">{unit.full_rental_price}</div>
                                                        }
                                                    </>
                                                );
                                            }
                                        })()}
                                    </div>
                                    <div
                                        className="btn btn-sm btn-primary position-absolute text-uppercase"
                                        style={{  bottom: '20px', right: '15px' }}

                                    >
                                        {lang.get('portal.view')}
                                    </div>
                                </div>
                                <div className="mb-3 mt-2 mt-md-0">{unit.full_address}</div>
                                <div className="h6"><FontAwesomeIcon icon={faRulerTriangle} size="lg" className="mr-1" /> {unit.surface_formatted}</div>
                                <div className="h6 mt-3">
                                    {unit.subtypes && unit.subtypes.length > 0 &&
                                        unit.subtypes.map((subtype, index) => (
                                            <span
                                                key={index}
                                                className="badge badge-light mr-1"
                                            >
                                                {subtype}
                                            </span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <FsLightbox
                        toggler={(lightboxControllers[unit.id] || {}).toggler || false}
                        sources={[...unit.images].map((single_unit) => {
                            return single_unit.url
                        })}
                        slide={(lightboxControllers[unit.id] || {}).slide || 1}
                        key={unit.id}
                        onClose={props.onClose}
                        allowFullScreen={false}
                    />

                    <Modal
                        isOpen={isOpen && selectedUnitId === unit.id}
                        toggle={() => toggleModal(unit.id)}
                        keyboard={false}
                    >
                        <ModalHeader toggle={() => toggleModal(unit.id)}>
                            {unit.name}
                        </ModalHeader>
                        <ModalBody>
                            {unit.images && unit.images.length > 0 && (
                                <div className="mb-2">
                                    <div className="position-relative rounded overflow-hidden" style={{ maxHeight: '500px' }}>
                                        {/* Main large image (Funda style) */}
                                        <div
                                            onClick={() => openLightboxOnSlide(unit.id, 1)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div style={{
                                                position: 'relative',
                                                overflow: 'hidden',
                                                paddingTop: '56.25%', /* 16:9 aspect ratio */
                                                height: '0'
                                            }}>
                                                <img
                                                    src={unit.images[0].url}
                                                    alt={`${unit.name} - Image 1`}
                                                    className="unit-image"
                                                    style={{
                                                        objectFit: 'cover',
                                                        objectPosition: 'center',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%'
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Small thumbnails at the bottom */}
                                        {unit.images.length > 1 && (
                                            <div className="d-flex mt-2 overflow-auto" style={{ gap: '4px' }}>
                                                {unit.images.slice(0, Math.min(5, unit.images.length)).map((image, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => openLightboxOnSlide(unit.id, index + 1)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            flexShrink: 0,
                                                            width: '80px',
                                                            height: '60px',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        <img
                                                            src={image.url}
                                                            alt={`${unit.name} - Thumbnail ${index + 1}`}
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                borderRadius: '4px'
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                                {unit.images.length > 5 && (
                                                    <div
                                                        onClick={() => openLightboxOnSlide(unit.id, 1)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            flexShrink: 0,
                                                            width: '80px',
                                                            height: '60px',
                                                            position: 'relative',
                                                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        +{unit.images.length - 5}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Details */}
                            <div className="mb-3">
                                <div className="row">
                                    {unit.surface_formatted &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{lang.get('portal.surface')}: </strong>
                                            {unit.surface_formatted}
                                        </div>
                                    }
                                    {unit.rental_status &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{unit.rental_status && unit.sales_status ? lang.get('portal.rental_status') : lang.get('portal.status')}: </strong>
                                            <span
                                                className={`badge ${unit.raw_rental_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                            >
                                                {unit.rental_status}
                                            </span>
                                        </div>
                                    }
                                    {unit.sales_status &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{unit.rental_status && unit.sales_status ? lang.get('portal.sales_status') : lang.get('portal.status')}: </strong>
                                            <span
                                                className={`badge ${unit.raw_sales_status === "available" ? "badge-success" : "badge-info"} text-lowercase`}
                                            >
                                                {unit.sales_status}
                                            </span>
                                        </div>
                                    }
                                    {unit.full_rental_price &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{lang.get('portal.rental_price')}: </strong>
                                            {unit.full_rental_price}
                                        </div>
                                    }
                                    {unit.full_sales_price &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{lang.get('portal.manual_price')}: </strong>
                                            {unit.full_sales_price}
                                        </div>
                                    }
                                    {unit.service_costs &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{lang.get('portal.service_costs')}: </strong>
                                            {unit.service_costs}
                                        </div>
                                    }
                                    {unit.full_address &&
                                        <div className="col-md-6 mb-2">
                                            <strong>Adres: </strong>
                                            {unit.full_address}
                                        </div>
                                    }
                                    {(unit.subtypes && unit.subtypes.length > 0) &&
                                        <div className="col-md-6 mb-2">
                                            <strong>{lang.get('portal.type')}: </strong>
                                            {unit.subtypes.map((subtype, index) => (
                                                <span
                                                    key={index}
                                                    className="badge badge-light mr-1"
                                                >
                                                    {subtype}
                                                </span>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>

                            {/* Description */}
                            {unit.description && (
                                <div className="mb-3">
                                    <h5>{lang.get('portal.description')}</h5>
                                    <div dangerouslySetInnerHTML={{ __html: unit.description}}></div>
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <div className="btn btn-sm btn-primary text-uppercase" onClick={() => toggleModal(unit.id)}>
                                {lang.get('portal.close')}
                            </div>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
            )}
        </>
    )

}

export default HeaderFooterHOC(Units, 'units');
